import { HttpErrorResponse } from '@angular/common/http';

export class ActionFailureResponse {
  constructor(
    public readonly error: HttpErrorResponse,
    public readonly messageDetail: string | null,
  ) {}
}
